import { CSSProperties } from "@material-ui/core/styles/withStyles";

const slotContainer: CSSProperties = {
  position: "relative",
  height: 157,
  overflowY: "scroll",
};

export const styles = {
  slotContainer,
};
